import { useEffect } from 'react';

/**
 * Custom hook til at opdatere sidetitel og meta description dynamisk.
 * @param {string} title - Sidetitlen (f.eks. 'Om os')
 * @param {string} description - Meta beskrivelsen til SEO
 */
export default function useDocumentMeta(title, description, ogImage = '') {
  useEffect(() => {
    // Opdater sidetitel - hvis den allerede indeholder '|', bruges den som helhed
    const finalTitle = title.includes('|') ? title : `${title} | LIVSLYST ApS`;
    document.title = finalTitle;

    // Find eller opret meta description tag
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Find eller opret Open Graph tags til deling
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', finalTitle);

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', description);

    // Open Graph Image
    let ogImageTag = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      if (!ogImageTag) {
        ogImageTag = document.createElement('meta');
        ogImageTag.setAttribute('property', 'og:image');
        document.head.appendChild(ogImageTag);
      }
      ogImageTag.setAttribute('content', ogImage);
    } else if (ogImageTag) {
      ogImageTag.remove();
    }

    // Twitter tags
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (!twitterTitle) {
      twitterTitle = document.createElement('meta');
      twitterTitle.setAttribute('name', 'twitter:title');
      document.head.appendChild(twitterTitle);
    }
    twitterTitle.setAttribute('content', finalTitle);

    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (!twitterDescription) {
      twitterDescription = document.createElement('meta');
      twitterDescription.setAttribute('name', 'twitter:description');
      document.head.appendChild(twitterDescription);
    }
    twitterDescription.setAttribute('content', description);

    let twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (ogImage) {
      if (!twitterImage) {
        twitterImage = document.createElement('meta');
        twitterImage.setAttribute('name', 'twitter:image');
        document.head.appendChild(twitterImage);
      }
      twitterImage.setAttribute('content', ogImage);
    } else if (twitterImage) {
      twitterImage.remove();
    }

  }, [title, description, ogImage]);
}
